import React from "react";
import SlidingPanel from "react-sliding-side-panel";
import {
  faTimes,
  faPencilAlt,
  faTrashAlt,
  faArrowLeft,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";

const SliderPanel = ({
  isOpen,
  children,
  size,
  type = "right",
  onClose,
  showCancel = true,
  backdropClicked,
  screen,
  showEdit = false,
  onEdit,
  showSave = false,
  onSave,
  showCancelButton = false,
  isMapper = false,
  showBackButton = false,
  showDeleteButton = false,
  onDelete,
  showHeader = false,
  header = "",
  headerClass = "",
  showSeparator = false,
}) => {
  const sliderClass =
    screen === "plan-group"
      ? "plan-group-slider-content"
      : "slider-content p-30";
  return (
    <SlidingPanel
      isOpen={isOpen}
      size={size}
      type={type}
      backdropClicked={backdropClicked}
    >
      <div className="d-flex flex-row justify-content-between p-30">
        <div className="d-flex align-items-end">
          {showHeader && <p className={headerClass}>{header}</p>}
        </div>
        <div className="d-flex flex-row justify-content-between">
          {showBackButton === true ? (
            <div className="slider-back-button" onClick={onClose}>
              <FontAwesomeIcon icon={faArrowLeft} />
              <span className="slider-back-label">Back</span>
            </div>
          ) : null}
          {showDeleteButton === true ? (
            <div className="slider-delete-button" onClick={onDelete}>
              <Button variant="danger">Delete</Button>
              {/* <FontAwesomeIcon icon={faTrashAlt} /> Delete */}
            </div>
          ) : null}
          {showEdit === true ? (
            <div className="slider-edit-button" onClick={onEdit}>
              <Button variant="primary">Edit</Button>
              {/* <FontAwesomeIcon icon={faPencilAlt} /> */}
            </div>
          ) : null}
          {showCancel === true ? (
            <div className="slider-close-button" onClick={onClose}>
              {isMapper ? (
                <FontAwesomeIcon icon={faTimes} />
              ) : (
                <Button variant="secondary">Close</Button>
              )}
              {/* <FontAwesomeIcon icon={faTimes} /> */}
            </div>
          ) : null}
          {showCancelButton === true ? (
            <div className="slider-cancel-button" onClick={onClose}>
              <Button variant="secondary">Cancel</Button>
            </div>
          ) : null}
          {showSave === true ? (
            <div className="slider-save-button" onClick={onSave}>
              <Button variant="primary">{isMapper ? "Select" : "Save"}</Button>
            </div>
          ) : null}
        </div>
      </div>
      {showSeparator && <hr className="ml-3 mr-3" />}
      <div className={sliderClass}>{children}</div>
    </SlidingPanel>
  );
};

export default SliderPanel;
